import { EstimateService } from "projects/estimate/src/app/estimate.service";
import { Level } from "../../interfaces/input-interfaces";
import { EventEmitter } from '@angular/core';
import { Subscription } from "rxjs";
import * as PROMPTS from '../../data/prompt.constant';

export class Prompt {
    private maxRetries = 1;
    private tries = 0;
    private response: string;

    constructor(
        private progress: EstimateService,
        private name: Level,
        private prompt: string,
        private data: {},
        private model = 'text-bison',
        private jsonResponse = false,
        private paramOption = 'strict',
        private eventEmitModel?: EventEmitter<any>,
        private enableLoading = true,
        private refinementPhase = false,
        private refinementMilestone = false
    ) {
        if (name) {
            this.prompt = this.replace(this.prompt);
            this.setLoading();
            this.askModel();
        }
    }

    replace(prompt: string): string {
        var promptEdit = prompt;
        for (const key in this.data) {
            const toReplace = new RegExp(`{${key}}`, 'g');
            promptEdit = promptEdit.replace(toReplace, this.data[key]);
        }
        return promptEdit
    }

    askModel(): void {
        if (this.enableLoading) this.progress.enablePage(false);
        if (this.model === 'eventEmitModel') {
            this.eventEmitModel.emit({
                promptString: this.prompt,
                model: "text-bison"
            });
        }
        else {
            const questionSub = this.progress.askModel(this.prompt, this.model, this.paramOption).subscribe(
                (response) => {
                    this.handleResponse(response, questionSub)
                }
            )
        }
    }

    handleResponse(response: any, questionSub: Subscription): void {
        try {
            // retry if json is invalid or error
            if (response['model_responses'][0]) {
                if (this.jsonResponse) {
                    this.response = this.progress.validateJsonResponse(
                        response['model_responses'][0]
                    );

                    if (this.refinementPhase) {
                        this.handlePhaseRefinement();
                    }
                    else if (this.refinementMilestone) {
                        this.handleMilestoneRefinement();
                    }
                    else {
                        this.setProcessed();
                    }
                }
                else {
                    this.response = response['model_responses'][0];
                    this.setProcessed();
                }
            }
            else {
                this.retry(questionSub)
            }
        } catch {
            this.retry(questionSub, response['model_responses'][0])
        }
    }

    handlePhaseRefinement(): void {
        this.refinementPhase = false;

        const prompt = this.replace(PROMPTS.stepThreeRefinement + this.response)

        const refinementPhaseSub = this.progress.askModel(prompt, this.model, 'strict').subscribe(
            (response) => {
                this.handleResponse(response, refinementPhaseSub)
            }
        )
    }

    handleMilestoneRefinement(): void {
        this.refinementMilestone = false;
        // const response: Phase = JSON.parse(this.response)
        // response.phaseRisk = { "riskLevel": "<choose high, medium, low>", "riskDescription": "<insert detailed description>" }
        // response.phaseDetails = "<insert detailed description>"
        // response.phaseMilestones.forEach((milestone) => {
        //     milestone.milestoneDetails = "<insert detailed description>"
        // })

        const prompt = this.replace(PROMPTS.stepFourRefinement + this.response
            .replace(new RegExp(`DO-NOT-CHANGE-THIS-TEXT`, 'g'), '<REPLACE-TIME-VARIABLE>')
        )

        const refinementMilestoneSub = this.progress.askModel(prompt, this.model, 'not-strictly-strict').subscribe(
            (response) => {
                this.handleResponse(response, refinementMilestoneSub)

            }
        )
    }

    retry(questionSub: Subscription, response?: any): boolean {
        if (this.tries <= this.maxRetries) {
            this.tries += 1;
            this.askModel();
            questionSub.unsubscribe();
            return true
        }
        if (response) { this.setError(response) } else {
            this.setError()
        }
        this.progress.enablePage(true);
        return false
    }

    setLoading(): void {
        this.progress.setProgress({
            level: this.name,
            status: 'loading',
            prompt: this.prompt
        });
    }

    setProcessed(response?: string): void {
        if (response) this.response = response;
        var currentResponse: Array<string> = this.progress.store.getValue()[this.name].response;
        if (currentResponse) {
            currentResponse = currentResponse.concat([this.response]);
        }
        else {
            currentResponse = [].concat([this.response])
        }
        this.progress.setProgress({
            level: this.name,
            status: 'afterInput',
            response: currentResponse
        });
    }

    setDisplayed(feedback?: Array<string>): void {
        this.progress.setProgress({
            level: this.name,
            status: 'afterOutput',
            feedback: feedback
        });
    }

    setDone(): void {
        this.progress.setProgress({
            level: this.name,
            status: 'done'
        });
    }

    reset(): void {
        this.progress.resetLevel({
            level: this.name,
            status: 'init'
        });
    }

    setError(response?: any): void {
        this.progress.setProgress({
            level: this.name,
            status: 'error'
        });
    }
}
